import React from 'react'
import PropTypes from 'prop-types'
import ButtonBase from '@mui/material/ButtonBase'
import Tooltip from '@mui/material/Tooltip'
import { BOT } from '../../theme/tokens'
import CrescentMark from './CrescentMark'

// Above the page, its sticky parts and the header (drawer + 1), below
// dialogs and menus (1300) and toasts (1400).
export const BOT_Z_INDEX = 1150

/**
 * The round button that opens BhanzuBot: the Bhanzu crescent on Deep Blue,
 * bottom right (24px from the edges, 16px on a phone), with an orange
 * focus ring. Hidden while the panel is open.
 */
const Launcher = ({ onOpen }) => (
    <Tooltip title="Ask BhanzuBot" placement="left">
        <ButtonBase
            aria-label="Ask BhanzuBot"
            onClick={onOpen}
            data-testid="bot-launcher"
            sx={{
                position: 'fixed',
                right: { xs: 16, sm: 24 },
                bottom: { xs: 16, sm: 24 },
                zIndex: BOT_Z_INDEX,
                width: 56,
                height: 56,
                borderRadius: '50%',
                backgroundColor: BOT.launcherBg,
                color: BOT.launcherFg,
                border: `1px solid ${BOT.launcherBorder}`,
                boxShadow: BOT.launcherShadow,
                '&.Mui-focusVisible': {
                    outline: `2px solid ${BOT.focusRing}`,
                    outlineOffset: 2,
                },
            }}
        >
            <CrescentMark size={30} />
        </ButtonBase>
    </Tooltip>
)

Launcher.propTypes = { onOpen: PropTypes.func.isRequired }

export default Launcher
